<template>
  <form>
    <div class="form-wrap">
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お名前
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.name }}
          </span>
        </div>
      </div>
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お客様のメールアドレス
            <br class="pc">
            （ご連絡先）
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.email }}
          </span>
        </div>
      </div>
      <div class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            お問い合わせ内容
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.type }}
          </span>
        </div>
      </div>
      <div
        v-if="form.type!=='配信停止について' && form.type!=='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            件名
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.subject }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label"
            for="release_title">
            <span v-if="form.type==='キャンペーン応募'">応募するリリースタイトル</span>
            <span v-else>対象リリースタイトル</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.release_title }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' || form.type==='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label"
            for="artist_name">
            <span v-if="form.type==='キャンペーン応募'">応募する対象アーティスト名</span>
            <span v-else>対象アーティスト名</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.artist_name }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' && isBtoC"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            リリースID
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.release_id }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type==='配信停止について' && isBtoB"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            対象JANコード
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text">
            {{ form.jan }}
          </span>
        </div>
      </div>

      <div
        v-if="form.type!=='キャンペーン応募'"
        class="form-group form-group--last form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            <span v-if="form.type==='配信停止について'">配信停止理由</span>
            <span v-else>お問い合わせ（内容の詳細）</span>
          </label>
        </div>
        <div class="form-item">
          <span class="form-item-confirm-text indent-contact-body">
            {{ form.body }}
          </span>
        </div>
      </div>
      <div
        v-if="form.type!=='キャンペーン応募'"
        class="form-group form-group-confirm">
        <div class="form-label">
          <label
            class="control-label">
            添付ファイル
          </label>
        </div>
        <div class="form-item">
          <img
            v-if="image"
            style="max-width: 320px"
            :src="image">
        </div>
      </div>
    </div>
    <div class="c-btn-wrap">
      <a
        class="c-btn"
        @click.prevent="onSendClicked">
        送信する
        <span class="c-btn__icon-arrow">
        </span>
      </a>
      <a
        class="c-btn c-btn--back c-btn--back-left"
        @click.prevent="onChangeClicked">
        変更する
        <span class="c-btn__icon-arrow c-btn__icon-arrow--left">
        </span>
      </a>
    </div>
  </form>
</template>

<script>
export default {
  name: 'ContactConfirm',
  props: {
    form: {
      type: Object,
      required: true,
    },
    image: {
      type: String,
      require: false,
      default: null,
    },
  },
  methods: {
    onChangeClicked() {
      this.$emit('change-clicked')
    },
    onSendClicked() {
      this.$emit('send-clicked')
    },
  },
}
</script>

<style scoped>
.indent-contact-body {
  white-space: pre-line;
  word-break: break-all;
}
</style>
